<script>
export default {
  props: ["data"],
};
</script>
<template>
  <div class="team-member-area section-space--inner--60 bg-hom">
    <div class="bg-home--jajaran"></div>
    <div class="container mt-5">
      <div class="row text-center mb-2">
        <div class="col-lg-12">
          <h3 class="text-color-green font-size-24">
            <span class="span-hr-green-left"></span>JAJARAN
          </h3>
          <br />
          <!-- <h2>Jajaran SMA Negeri Indonesia</h2>
                    <p class="font-size-15">Berikut Jajaran {{ this.meta.name }}</p> -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="team-member-wrapper">
            <div class="row" v-if="data.length > 0">
              <!--Team member start-->
              <div
                class="col-lg-4 col-sm-6 col-12 section-space--bottom--30"
                v-for="teamMember in data.slice(0, 3)"
                :key="teamMember.id"
              >
                <div class="team">
                  <div class="text-center bg-white pt-5">
                    <img
                      :src="teamMember.image"
                      alt="team member image"
                      class="circular--landscape position-relative"
                    />
                  </div>
                  <!-- <div class="bg-home--jajaran2"></div> -->
                  <div
                    class="content position-relative"
                    style="background: #FFFFFF;"
                  >
                    <h3 class="title">{{ teamMember.title }}</h3>
                    <span style="color: #00A24B;" class="font-weight-bold">{{
                      teamMember.body
                    }}</span>
                    <!-- <a href="mailto:info@example.com" class="email">{{ teamMember.email }}</a> -->
                    <!--<div class="social">
                                            <a :href="item.link" :class="item.addClass" target="_blank" v-for="item in teamMember.social" :key="item.id">
                                                <i :class="item.icon"></i>
                                            </a>
                                        </div>
                                        -->
                    <div class="social">
                      <a
                        href="https://www.facebook.com"
                        target="_blank"
                        class="facebook"
                        ><i class="fa fa-facebook"></i></a
                      ><a
                        href="https://twitter.com"
                        target="_blank"
                        class="twitter"
                        ><i class="fa fa-twitter"></i></a
                      ><a
                        href="https://www.linkedin.com"
                        target="_blank"
                        class="linkedin"
                        ><i class="fa fa-linkedin"></i></a
                      ><a
                        href="https://www.google.com"
                        target="_blank"
                        class="google"
                        ><i class="fa fa-google-plus"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
              <!--Team member end-->
            </div>

            <div class="row" v-else>
              <!--Team member start-->
              <div class="col-lg-4 col-sm-6 col-12 section-space--bottom--30">
                <div class="team">
                  <div class="text-center bg-white pt-5">
                    <img
                      src="@/assets/images/global/list_empty.png"
                      alt="team member image"
                      class="circular--landscape position-relative"
                    />
                  </div>
                  <!-- <div class="bg-home--jajaran2"></div> -->
                  <div
                    class="content position-relative"
                    style="background: #FFFFFF;"
                  >
                    <h3 class="title">Data belum tersedia</h3>
                    <span style="color: #00A24B;" class="font-weight-bold"
                      >Data belum tersedia</span
                    >
                    <!-- <a href="mailto:info@example.com" class="email">{{ teamMember.email }}</a> -->
                    <!--<div class="social">
                                            <a :href="item.link" :class="item.addClass" target="_blank" v-for="item in teamMember.social" :key="item.id">
                                                <i :class="item.icon"></i>
                                            </a>
                                        </div>
                                        -->
                    <div class="social">
                      <a
                        href="https://www.facebook.com"
                        target="_blank"
                        class="facebook"
                        ><i class="fa fa-facebook"></i></a
                      ><a
                        href="https://twitter.com"
                        target="_blank"
                        class="twitter"
                        ><i class="fa fa-twitter"></i></a
                      ><a
                        href="https://www.linkedin.com"
                        target="_blank"
                        class="linkedin"
                        ><i class="fa fa-linkedin"></i></a
                      ><a
                        href="https://www.google.com"
                        target="_blank"
                        class="google"
                        ><i class="fa fa-google-plus"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-sm-6 col-12 section-space--bottom--30">
                <div class="team">
                  <div class="text-center bg-white pt-5">
                    <img
                      src="@/assets/images/global/list_empty.png"
                      alt="team member image"
                      class="circular--landscape position-relative"
                    />
                  </div>
                  <!-- <div class="bg-home--jajaran2"></div> -->
                  <div
                    class="content position-relative"
                    style="background: #FFFFFF;"
                  >
                    <h3 class="title">Data belum tersedia</h3>
                    <span style="color: #00A24B;" class="font-weight-bold"
                      >Data belum tersedia</span
                    >
                    <!-- <a href="mailto:info@example.com" class="email">{{ teamMember.email }}</a> -->
                    <!--<div class="social">
                                            <a :href="item.link" :class="item.addClass" target="_blank" v-for="item in teamMember.social" :key="item.id">
                                                <i :class="item.icon"></i>
                                            </a>
                                        </div>
                                        -->
                    <div class="social">
                      <a
                        href="https://www.facebook.com"
                        target="_blank"
                        class="facebook"
                        ><i class="fa fa-facebook"></i></a
                      ><a
                        href="https://twitter.com"
                        target="_blank"
                        class="twitter"
                        ><i class="fa fa-twitter"></i></a
                      ><a
                        href="https://www.linkedin.com"
                        target="_blank"
                        class="linkedin"
                        ><i class="fa fa-linkedin"></i></a
                      ><a
                        href="https://www.google.com"
                        target="_blank"
                        class="google"
                        ><i class="fa fa-google-plus"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-sm-6 col-12 section-space--bottom--30">
                <div class="team">
                  <div class="text-center bg-white pt-5">
                    <img
                      src="@/assets/images/global/list_empty.png"
                      alt="team member image"
                      class="circular--landscape position-relative"
                    />
                  </div>
                  <!-- <div class="bg-home--jajaran2"></div> -->
                  <div
                    class="content position-relative"
                    style="background: #FFFFFF;"
                  >
                    <h3 class="title">Data belum tersedia</h3>
                    <span style="color: #00A24B;" class="font-weight-bold"
                      >Data belum tersedia</span
                    >
                    <!-- <a href="mailto:info@example.com" class="email">{{ teamMember.email }}</a> -->
                    <!--<div class="social">
                                            <a :href="item.link" :class="item.addClass" target="_blank" v-for="item in teamMember.social" :key="item.id">
                                                <i :class="item.icon"></i>
                                            </a>
                                        </div>
                                        -->
                    <div class="social">
                      <a
                        href="https://www.facebook.com"
                        target="_blank"
                        class="facebook"
                        ><i class="fa fa-facebook"></i></a
                      ><a
                        href="https://twitter.com"
                        target="_blank"
                        class="twitter"
                        ><i class="fa fa-twitter"></i></a
                      ><a
                        href="https://www.linkedin.com"
                        target="_blank"
                        class="linkedin"
                        ><i class="fa fa-linkedin"></i></a
                      ><a
                        href="https://www.google.com"
                        target="_blank"
                        class="google"
                        ><i class="fa fa-google-plus"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
              <!--Team member end-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/scss/6-responsive/template-green/index.scss";
</style>
